import { render, staticRenderFns } from "./CompanyDetail.vue?vue&type=template&id=0f6b54d7&scoped=true"
import script from "./CompanyDetail.vue?vue&type=script&lang=js"
export * from "./CompanyDetail.vue?vue&type=script&lang=js"
import style0 from "./CompanyDetail.vue?vue&type=style&index=0&id=0f6b54d7&prod&scoped=true&lang=css"
import style1 from "./CompanyDetail.vue?vue&type=style&index=1&id=0f6b54d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6b54d7",
  null
  
)

export default component.exports